<template>
    <section class="py-5 bg-light">
        <div class="container p-5">
            <div class="d-flex w-100 justify-content-center pb-5 mx-auto" style="max-width: 1000px;">
                <div class="d-flex flex-column w-100 justify-content-start align-items-start">
                    <div class="d-flex w-100 py-0 flex-column flex-md-row justify-content-around align-items-center">
                        <img class="rounded-xl mx-4 mx-lg-5 my-4" alt="" loading="lazy" decoding="async" style="max-width: 280px;"
                            src="@/assets/img/6v6_for_players.jpg">
                        <div class="d-flex py-0 flex-column align-items-start mx-4 mx-lg-5" style="max-width: 450px; width: 80%;">
                            <h1 class="font-weight-bold"><span class="text-primary">6v6</span> Pour Joueurs</h1>
                            <p class="mb-4 text-sm">
                                Joue davantage. Se sentir mieux. Le football rend chaque semaine meilleure, c'est aussi
                                simple que cela. Rapide, amusant et idéal pour garder la forme, une partie de foot à 5
                                ou 6 avec "6v6 foot" est bien plus qu'un simple jeu. C'est l'amitié, les souvenirs et
                                ces victoires de dernière minute qui vous attirent sans cesse.
                            </p>
                            <div class="d-flex w-100 justify-content-center justify-content-md-start">
                                <a class="btn btn-primary rounded-pill text-dark text-sm" href="/search">
                                    Réserver un match
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex w-100 justify-content-center pt-5 mx-auto" style="max-width: 1000px;">
                <div class="d-flex flex-column w-100 justify-content-start align-items-start">
                    <div class="d-flex w-100 py-0 flex-column flex-md-row justify-content-around align-items-center">
                        <div class="d-flex py-0 flex-column align-items-start order-1 order-md-0 mx-4 mx-lg-5" style="max-width: 450px; width: 80%;">
                            <h1 class="font-weight-bold"><span class="text-primary">6v6</span> Pour Stades</h1>
                            <p class="mb-4 text-sm">
                                Gérez votre terrain de football à partir d'un seul endroit. Acceptez des réservations en
                                ligne, gérez vos clients, organisez des activités sociales et améliorez l'occupation de
                                vos terrains.
                            </p>
                            <div class="d-flex w-100 justify-content-center justify-content-md-start">
                                <a class="btn btn-primary rounded-pill text-dark text-sm" href="/become-partner">
                                    Devenir Partenaire
                                </a>
                            </div>
                        </div>
                        <img class="rounded-xl order-0 order-md-1 mx-4 mx-lg-5 my-4" alt="" loading="lazy" decoding="async" style="max-width: 280px;" 
                            src="@/assets/img/6v6_for_partners.jpg">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
